import { combineReducers } from "redux";
import commonReducer from "./commonReducer";
const appReducer = combineReducers({
  commonReducer,
});
const reducer = (state, action) => {
  return appReducer(state, action);
};
export default reducer;
